import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=49cb8a86&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=49cb8a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cb8a86",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages2/team/index/index.vue"
export default component.exports